import { Field, Int, ObjectType } from '@nestjs/graphql'
import { NotificationDto } from '../notifications'

@ObjectType()
export class ArcNotificationsDto {
  @Field(t => NotificationDto)
  notification!: NotificationDto

  @Field(t => Int)
  sentCount!: number

  @Field(t => Int)
  totalCount!: number
}
